class MadeInProductShare extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';
    this.button = this.querySelector('[data-mi-share-button]');
    this.status = this.querySelector('[data-mi-share-status]');
    this.button?.addEventListener('click', () => this.share());
  }

  async share() {
    const title = this.dataset.shareTitle || document.title;
    const url = this.dataset.shareUrl || window.location.href;
    const text = this.dataset.shareText || title;

    if (navigator.share) {
      try {
        await navigator.share({ title, text, url });
        this.announce('تم فتح خيارات المشاركة');
        return;
      } catch (error) {
        if (error?.name === 'AbortError') return;
      }
    }

    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const input = document.createElement('textarea');
      input.value = url;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.append(input);
      input.select();
      document.execCommand('copy');
      input.remove();
    }
    this.announce('تم نسخ رابط المنتج');
  }

  announce(message) {
    if (!this.status) return;
    this.status.textContent = message;
    this.classList.add('is-success');
    window.clearTimeout(this.statusTimer);
    this.statusTimer = window.setTimeout(() => {
      this.status.textContent = '';
      this.classList.remove('is-success');
    }, 3500);
  }
}

if (!customElements.get('made-in-product-share')) {
  customElements.define('made-in-product-share', MadeInProductShare);
}
